// import Repository from '@/repositories/marketing'
import {MarketingRepo} from '@core/repositories'
import config from "@core/config/app.config.js"
const resource = '/widgets'

export default {
  getMonthlyEmailUsage(config){
      return MarketingRepo.get(`${resource}/monthly_email_usage.json`, config)
  },
  getSMSVolume(config){
      return MarketingRepo.get(`${resource}/sms_volume.json`, config)
  },
}
